import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
var func = {}; // 状态码转换

func.TranslationSTATUS = function (item) {
  switch (item.STATUS) {
    case 1:
      return '未处理';
    // 未处理

    case 2:
      return '审核';
    // 审核

    case 3:
      return '作废';
    // 作废

    case 4:
      return '在途';
    // 在途

    case 5:
      return '收货';
    // 收货
  }
}; // 根据状态切换颜色


func.switchColor = function (item) {
  switch (item.STATUS) {
    case 1:
      return 'color:#939599';
    // 未处理

    case 2:
      return 'color:#f8a324';
    // 审核

    case 3:
      return 'color:#f56c6c';
    // 作废

    case 4:
      return 'color:#296bef';
    // 在途

    case 5:
      return 'color:#00bb7c';
    // 收货
  }
};

func.formatUrl = function (userApi) {
  var envList = [{
    VarName: 'VUE_APP_API',
    UrlPrefix: ''
  }, {
    VarName: 'VUE_APP_PRINT_TPL',
    UrlPrefix: ''
  }, {
    VarName: 'VUE_APP_DOWN',
    UrlPrefix: ''
  }, {
    VarName: 'VUE_APP_IWMS_API',
    UrlPrefix: ''
  }, {
    VarName: 'VUE_APP_FILE_PATH',
    UrlPrefix: ''
  }];
  var url = '';
  var hostname = location.hostname;

  if (process.env.VUE_APP_COOKIES_NAME === 'test') {
    if (hostname.includes('122.227.159.58')) {
      url = userApi.replace(':46074/api/', '');
      envList.forEach(function (item) {
        if (item.VarName === 'VUE_APP_API') {
          item.UrlPrefix = url + ':32702/api';
        } else if (item.VarName === 'VUE_APP_PRINT_TPL') {
          item.UrlPrefix = url + ':56066/';
        } else if (item.VarName === 'VUE_APP_DOWN') {
          item.UrlPrefix = url + ':42702';
        } else if (item.VarName === 'VUE_APP_IWMS_API') {
          item.UrlPrefix = url + ':46067/api/';
        } else if (item.VarName === 'VUE_APP_FILE_PATH') {
          item.UrlPrefix = url + ':46074';
        }
      });
    } else if (hostname.includes('192.168.1.138')) {
      url = userApi.replace(':56074/api/', '');
      envList.forEach(function (item) {
        if (item.VarName === 'VUE_APP_API') {
          item.UrlPrefix = url + ':42702/api';
        } else if (item.VarName === 'VUE_APP_PRINT_TPL') {
          item.UrlPrefix = url + ':56066/';
        } else if (item.VarName === 'VUE_APP_DOWN') {
          item.UrlPrefix = url + ':42702';
        } else if (item.VarName === 'VUE_APP_IWMS_API') {
          item.UrlPrefix = url + ':56067/api/';
        } else if (item.VarName === 'VUE_APP_FILE_PATH') {
          item.UrlPrefix = url + ':56074';
        }
      });
    } else {
      url = userApi.replace(':56074/api/', '');
      envList.forEach(function (item) {
        if (item.VarName === 'VUE_APP_API') {
          item.UrlPrefix = url + ':42702/api';
        } else if (item.VarName === 'VUE_APP_PRINT_TPL') {
          item.UrlPrefix = url + ':56066/';
        } else if (item.VarName === 'VUE_APP_DOWN') {
          item.UrlPrefix = url + ':42702';
        } else if (item.VarName === 'VUE_APP_IWMS_API') {
          item.UrlPrefix = url + ':56067/api/';
        } else if (item.VarName === 'VUE_APP_FILE_PATH') {
          item.UrlPrefix = url + ':56074';
        }
      });
    }
  } else if (process.env.VUE_APP_COOKIES_NAME === 'pro') {
    url = userApi.replace(':56074/api/', '');
    envList.forEach(function (item) {
      if (item.VarName === 'VUE_APP_API') {
        item.UrlPrefix = url + ':42702/api';
      } else if (item.VarName === 'VUE_APP_PRINT_TPL') {
        item.UrlPrefix = url + ':56066/';
      } else if (item.VarName === 'VUE_APP_DOWN') {
        item.UrlPrefix = url + ':42702';
      } else if (item.VarName === 'VUE_APP_IWMS_API') {
        item.UrlPrefix = url + ':56067/api/';
      } else if (item.VarName === 'VUE_APP_FILE_PATH') {
        item.UrlPrefix = url + ':56074';
      }
    });
  }

  return envList;
};

export default func;